/**
 * Mirrors App\Support\ProjectMaintenance on the client.
 */
export function isSiteUnderMaintenance() {
    if (typeof window === 'undefined') return false;
    if (window.__MAINTENANCE_APPLIES__ === false) return false;

    const data = window.__APP_DATA__;
    if (!data) return false;
    if (data.siteMaintenance === true) return true;

    return data.project?.deployed === false;
}

export function applyMaintenanceDocumentState() {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.add('app-ready', 'site-maintenance');
    document.body?.classList.add('site-maintenance');
}

export function markAppReady() {
    if (typeof document === 'undefined') return;
    const html = document.documentElement;
    if (html.classList.contains('app-ready')) return;
    html.classList.add('app-ready');

    setTimeout(() => {
        const node = document.getElementById('app-splash');
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }, 400);
}

/**
 * Splash overlay reveal — see resources/views/injections/head.blade.php.
 */
export function initSplashOverlay() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const reveal = () => requestAnimationFrame(markAppReady);

    const onDomReady = () => {
        const fontsReady =
            document.fonts && typeof document.fonts.ready?.then === 'function'
                ? document.fonts.ready
                : Promise.resolve();
        fontsReady.then(reveal, reveal);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
    } else {
        onDomReady();
    }

    setTimeout(markAppReady, 1500);
}
